const emailValidCharsRegexp = new RegExp("[^a-z0-9.!#$%&'*+/=?^_`{|}~-]+", 'g');

export function leaveOnlyEmailChars(str) {
  return str && str.replace(emailValidCharsRegexp, '');
}

export function isWixEmployeeEmail(email: string) {
  return /@wix\.com$/.test(email);
}
